import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppServerAPI } from '@sdbn/common';
import { ServiceResponse } from '@sdbn/common';
import { FilterType, Filter, PreviewFilter, FilterSortOrder } from './filter-administration.model';

@Injectable({
  providedIn: 'root'
})
export class FilterAdministrationService {

  constructor(
    private appServerAPI: AppServerAPI
  ) { }

  public getPreviewFilters(type: FilterType): Observable<PreviewFilter[]> {
    return this.appServerAPI.execute('/client/admin/filter', type);
  }

  public getFilter(filterId: number): Observable<Filter> {
    return this.appServerAPI.execute('/client/admin/filter/filter', filterId);
  }

  public saveFilter(filter: Filter): Observable<ServiceResponse> {
    return this.appServerAPI.execute('/client/admin/filter/save', filter);
  }

  public saveSortOrder(sortorder: FilterSortOrder[]): Observable<ServiceResponse> {
    return this.appServerAPI.execute('/client/admin/filter/save-sort-order', sortorder);
  }

  public deleteFilter(filterId: number): Observable<ServiceResponse> {
    return this.appServerAPI.execute('/client/admin/filter/delete', filterId);
  }
}
